/**
 * Labstep
 *
 * @module components/OrganizationPlan/Action/ViewPayments
 * @desc   View payments
 */

import { OrganizationInvoiceListContainer as OrganizationInvoiceList } from 'labstep-web/components/OrganizationInvoice/List';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { OrganizationPlanActionViewPaymentsProps } from './types';

export const OrganizationPlanActionViewPayments: React.FC<
  OrganizationPlanActionViewPaymentsProps
> = ({ organization }) => {
  return organization.is_stripe_subscription_set ? (
    <ModalDefault
      viewComponent={
        <ActionComponent
          text="View Payments"
          type="button"
          elementProps={{
            basic: true,
          }}
        />
      }
      content={<OrganizationInvoiceList />}
    />
  ) : null;
};
